module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data flex flex-center flex-column"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('p', {
    staticClass: "nopage-txt"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nopage-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/norecord.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69576fc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoData.vue
// module id = 887
// module chunks = 1